import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ProductPage from "@/pages/ProductPage";
import CaseStudiesIndex from "@/pages/CaseStudiesIndex";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import BlogIndex from "@/pages/BlogIndex";
import BlogPostPage from "@/pages/BlogPostPage";
import ScrollToHash from "@/components/ScrollToHash";
import { ThemeProvider, useTheme } from "@/components/ThemeProvider";

const ToastHost = () => {
  const { theme } = useTheme();
  return <Toaster position="top-right" richColors closeButton theme={theme} />;
};

function App() {
  return (
    <ThemeProvider>
      <div className="App font-body bg-white text-zinc-950 dark:bg-zinc-950 dark:text-zinc-100 transition-colors">
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/product" element={<Navigate to="/products/ai-inventory-compliance-governance" replace />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/case-studies" element={<CaseStudiesIndex />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
          </Routes>
        </BrowserRouter>
        <ToastHost />
      </div>
    </ThemeProvider>
  );
}

export default App;